module.exports = __webpack_public_path__ + "static/media/green-sticker.a4b48ee4.svg";